export default {
	title: "Card Transactions",
	subtitle: "Card Tokenization",
  path: "transaction_cc_tokenization",
	paragraph: "You can register a credit card for a specific customer, so you don’t need to register the same card every transaction. Customers can have their cards registered to make transactions.",
	request: {
    method: "POST", 
		endpoint: "/subject/:subject_id/credit_cards",
		payload: {
      "credit_card": {
        "card_number": "2584958561024786",
        "card_expiration_date": "12/2030",
        "card_brand": "Visa",
        "card_security_code": "333",
        "fullname": "Credit Card Holder Name"
      }
    },
		responses: {
      "data": {
        "status": "tokenized",
        "inserted_at": "2021-06-25T19:44:40.397583",
        "id": "788094b0-76fc-428a-bd1a-52489cef0dbe"
      }
    }
	},
  pathPayload: [
    {
      name: "subject_id",
      type: "string",
      required: true,
      description: "Person or Company's ID"
    }
  ],
	parameterPayload: [
    {
    name: "credit_card",
    type: "object",
    required: true,
    description: "An object containing all the required values needed"
  },
  {
		name: "credit_card.card_number",
		type: "string",
		required: true,
		description: "The card number without spaces"
    },
    {
      name: "credit_card.card_expiration_date",
      type: "string",
      required: true,
      description: "Card expiration date in MM/YY format"
    },
    {
      name: "credit_card.card_brand",
      type: "string",
      required: true,
      description: "Card brand, such as Visa, Mastercard, Amex or Elo"
    },
    {
      name: "credit_card.card_security_code",
      type: "string",
      required: true,
      description: "Partner's customer/company UUID"
    },
    {
      name: "credit_card.fullname",
      type: "string",
      required: true,
      description: "Cardholder's full name"
    },
  ],
	footerNotes: 'In the sandbox environment, all cards will be automatically registered as tokenized.',
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'Providing a invalid credit card',
        code: {
          "id": "788094b0-76fc-428a-bd1a-52489cef0dbe",
          "status": "not_tokenized"
        },
        solution: 'Provide a valid credit card and verify the card data and subject'
      },
       {
        description: 'Do not send the full credit card name',
        code: {
              "errors": {
                  "fullname": [
                      "can't be blank"
                  ]
              }
          },
        solution: 'Please provide full credit card name'
      },
      {
        description: 'Card number with less than 13 character(s)',
        code: {
              "errors": {
                  "card_number": [
                      "should be at least 13 character(s)"
                  ]
              }
          },
        solution: 'Please provide a valid credit card number'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardRegistration.js